
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const AGB = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-2xl font-bold mb-6 text-chrona-text">Allgemeine Geschäftsbedingungen</h1>
      
      <Card className="border-chrona-gray-800 bg-chrona-gray-900/60 mb-6">
        <CardHeader className="border-b border-chrona-gray-800">
          <CardTitle className="text-chrona-text">1. Geltungsbereich</CardTitle>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="space-y-4 text-chrona-gray-300">
            <p>
              Diese Allgemeinen Geschäftsbedingungen (nachfolgend "AGB") gelten für alle Verträge zwischen der CHRONA GmbH 
              (nachfolgend "CHRONA") und den Nutzern (nachfolgend "Kunde") der Plattform CHRONA (nachfolgend "Plattform").
            </p>
            <p>
              Die Plattform ist ein Online-Buchungssystem für Dienstleistungen verschiedener Anbieter wie Studios, Salons und Coaches 
              (nachfolgend "Anbieter"). CHRONA tritt dabei als Vermittler zwischen dem Kunden und dem Anbieter auf.
            </p>
            <p>
              Durch die Nutzung der Plattform und die Buchung von Dienstleistungen erkennt der Kunde diese AGB an. 
              Abweichende, entgegenstehende oder ergänzende AGB des Kunden oder Anbieters werden nur dann Vertragsbestandteil, 
              wenn CHRONA ihrer Geltung ausdrücklich zugestimmt hat.
            </p>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-chrona-gray-800 bg-chrona-gray-900/60 mb-6">
        <CardHeader className="border-b border-chrona-gray-800">
          <CardTitle className="text-chrona-text">2. Vertragsgegenstand & Vertragsschluss</CardTitle>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="space-y-4 text-chrona-gray-300">
            <p>
              CHRONA stellt eine Plattform zur Verfügung, auf der Kunden Termine für Dienstleistungen bei verschiedenen Anbietern 
              buchen können. Der Vertrag über die zu erbringende Dienstleistung kommt direkt zwischen dem Kunden und dem jeweiligen 
              Anbieter zustande.
            </p>
            <p>
              Die Darstellung der Dienstleistungen auf der Plattform stellt kein rechtlich bindendes Angebot, sondern eine 
              Aufforderung zur Abgabe eines Angebots dar. Durch das Absenden einer Buchung gibt der Kunde ein verbindliches 
              Angebot zum Abschluss eines Vertrags über die ausgewählte Dienstleistung ab.
            </p>
            <p>
              Der Vertrag zwischen dem Kunden und dem Anbieter kommt erst durch die Bestätigung der Buchung durch den Anbieter 
              zustande. Diese Bestätigung erfolgt per E-Mail an die vom Kunden angegebene E-Mail-Adresse.
            </p>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-chrona-gray-800 bg-chrona-gray-900/60 mb-6">
        <CardHeader className="border-b border-chrona-gray-800">
          <CardTitle className="text-chrona-text">3. Preise, Zahlungsbedingungen & Stornierung</CardTitle>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="space-y-4 text-chrona-gray-300">
            <p>
              Die auf der Plattform angegebenen Preise für Dienstleistungen werden von den jeweiligen Anbietern festgelegt 
              und enthalten die gesetzliche Mehrwertsteuer.
            </p>
            <p>
              Die Zahlung erfolgt über die auf der Plattform angebotenen Zahlungsmethoden und wird von CHRONA im Auftrag des 
              Anbieters abgewickelt. Mit der Buchung ermächtigt der Kunde CHRONA, den Buchungspreis vom angegebenen 
              Zahlungsmittel einzuziehen.
            </p>
            <p>
              Eine Stornierung durch den Kunden ist bis zu 24 Stunden vor dem gebuchten Termin kostenfrei möglich. Bei späterer 
              Stornierung oder Nichterscheinen kann der Anbieter eine Stornogebühr in Höhe von bis zu 100% des Buchungspreises erheben.
            </p>
            <p>
              Der Anbieter behält sich das Recht vor, Termine aus wichtigem Grund zu verschieben oder zu stornieren. 
              In diesem Fall wird der Kunde schnellstmöglich informiert und erhält entweder einen Ersatztermin oder eine 
              vollständige Rückerstattung bereits geleisteter Zahlungen.
            </p>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-chrona-gray-800 bg-chrona-gray-900/60 mb-6">
        <CardHeader className="border-b border-chrona-gray-800">
          <CardTitle className="text-chrona-text">4. Haftung</CardTitle>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="space-y-4 text-chrona-gray-300">
            <p>
              CHRONA übernimmt keine Haftung für die von den Anbietern erbrachten Dienstleistungen, deren Qualität oder 
              Eignung für bestimmte Zwecke des Kunden.
            </p>
            <p>
              Ansprüche des Kunden aus der Durchführung der gebuchten Dienstleistung sind direkt an den jeweiligen Anbieter zu richten.
            </p>
            <p>
              CHRONA haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie für Schäden aus der Verletzung des Lebens, 
              des Körpers oder der Gesundheit. Im Übrigen haftet CHRONA nur bei Verletzung einer Vertragspflicht, deren Erfüllung 
              die ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht und auf deren Einhaltung der Kunde regelmäßig 
              vertrauen darf, und zwar beschränkt auf den Ersatz des vorhersehbaren und typischen Schadens.
            </p>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-chrona-gray-800 bg-chrona-gray-900/60">
        <CardHeader className="border-b border-chrona-gray-800">
          <CardTitle className="text-chrona-text">5. Schlussbestimmungen</CardTitle>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="space-y-4 text-chrona-gray-300">
            <p>
              Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
            </p>
            <p>
              Ist der Kunde Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen, 
              ist ausschließlicher Gerichtsstand für alle Streitigkeiten aus diesem Vertrag der Sitz von CHRONA.
            </p>
            <p>
              Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, berührt dies die Wirksamkeit der übrigen 
              Bestimmungen nicht.
            </p>
          </div>
        </CardContent>
      </Card>
      
      <div className="mt-8 text-center text-chrona-gray-400">
        <p>Stand: Mai 2025 - CHRONA GmbH, Berlin</p>
      </div>
    </div>
  );
};

export default AGB;
